import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import {compose} from 'redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';
import CustomTextField from '../Input/CustomTextField';
import {withTranslation} from 'react-i18next';
import IntlMessage from '../../util/IntlMessage';

const styles = {
    form: {
        padding: '0 1em 1em 1em'
    },
    forgotPasswordButton: {
        textTransform: 'none',
        marginTop: '16px'
    }
};

class ChangePasswordForm extends Component {
    render() {
        const {t: translate, classes, handleSubmit, isLoading, onSubmit} = this.props;

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={classes.form}>
                    <Field
                        type="password"
                        name="newPassword"
                        label={<IntlMessage id='profile.security.fields.new_password'/>}
                        component={CustomTextField}
                        variant="outlined"
                        disabled={isLoading}
                    />
                    <Field
                        type="password"
                        name="confirmPassword"
                        label={<IntlMessage id='profile.security.fields.confirm_password'/>}
                        component={CustomTextField}
                        variant="outlined"
                        disabled={isLoading}
                    />
                    <Button
                        type='submit'
                        variant="raised"
                        size="medium"
                        fullWidth
                        className={`btn-primary tour-step-4 text-white ${classes.forgotPasswordButton}`}
                        color="primary"
                        disabled={isLoading}
                    >
                        {isLoading && (
                            <CircularProgress size={25} thickness={2}/>
                        )}
                        {translate('forgot_password.reset_password')}
                    </Button>
                </div>
            </form>
        );
    }
}

const EnhancedChangePassword = compose(
    withTranslation(),
    reduxForm({
        form: 'resetPassword',
        validate: (values, props) => {
            const errors = {};
            const {t: translate} = props;

            if (!values.newPassword) {
                errors.newPassword = [translate('common.validation.required')];
            } else if(values.newPassword.length < 6) {
                errors.newPassword = [translate('profile.security.validation.password_too_short')];
            }

            if (!values.confirmPassword) {
                errors.confirmPassword = translate('common.validation.required');
            } else if (values.confirmPassword !== values.newPassword) {
                errors.confirmPassword = [translate('profile.security.validation.password_not_same')];
            }

            return errors;
        }
    }),
    withStyles(styles)
);

export default EnhancedChangePassword(ChangePasswordForm);